<template>
  <div class="mainBox">
    <div class="mainTop w-12">
      <span style="cursor: pointer" @click="toHome" title="杭州市上城区事业单位公开招聘网上报名系统">
        杭州市上城区事业单位公开招聘网上报名系统
      </span>
      <span style="flex: 1"></span>
      <span v-if="$store.state.loginState == 0" @click="toLoginPage" class="loginBtn btn">
        立即登录
      </span>
      <span v-else class="">
        <span class="personalBtn" @click="skipToPersonalCenter">
          【个人中心】
        </span>
        欢迎您！{{ $store.state.userInfo.examineeName }}
        <span class="logoutBtn btn" @click="handleLogout"> 退出登录 </span>
      </span>
    </div>
    <div class="bannerBox">
      <div class="w-12">
        <h1 class="logoBox" @click="toHome">
<!--          <img src="../../../assets/images/bdlogo.png" title="杭州市上城区事业单位公开招聘网上报名系统" alt="" style="width: 240px;height: 80px;" />-->
          <span style="float: right">杭州市上城区事业单位公开招聘网上报名系统</span>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XWViewHeader",
  data() {
    return {};
  },
  methods: {
    toHome() {
      this.$router.push("/home/index");
    },
    toLoginPage() {
      console.log("前往登录");
      this.$router.push("/login");
    },
    handleLogout() {
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem(this.config.tokenName);
      this.$store.commit("loginStateChange", 0);
      this.$forceUpdate();
    },
    skipToPersonalCenter() {
      this.$router.push("/home/person");
    },
  },
};
</script>

<style scoped>
.mainBox {
  font-size: 0;
  background-color: #f2f2f2;
}

.mainTop {
  font-size: 0.8rem;
  padding: 5px 0;
  display: flex;
}

.loginBtn {
  color: #ea3737;
}

.logoutBtn {
  color: #ea3737;
  margin-left: 20px;
}

.personalBtn {
  cursor: pointer;
}

.personalBtn:hover {
  color: #ea3737;
}

.bannerBox {
  background-color: #fff;
  border-bottom: 2px solid #ea3737;
}

.logoBox {
  font-size: 36px;
  display: inline-block;
  cursor: pointer;
  height: 100px;
  width: 100%;
  line-height: 110px;
}

.logoBox img {
  /* height: 100%; */
  /* vertical-align: middle; */
}
</style>



// WEBPACK FOOTER //
// src/components/common/XWViewHeader/ViewHeader.vue